<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">券享生活</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 商家选择  开始 -->
    <div class="page_top"></div>
    <div class="page_taocan store_shop">
      <div class="page_taocan_list store_shopList">
        <div v-for="(item,index) in storeList" @click="todetail(index)" :class="item.storeselect ? 'page_taocan_box1':'page_taocan_box'"
          class="store_shopbox">
          <img class="store_shopboximg" :src="item.thumb" />
          <!-- <div class="shopping_des">{{item.name}}</div> -->
          <img v-if="item.storeselect" class="page_taocan_checkimg" src="/static/newprojecticon/chongzhicheck.png" />
        </div>
      </div>
    </div>
    <!-- 商家选择  结束 -->
    <!-- 套餐类型  开始 -->
    <div class="store_none"></div>
    <div v-for="(item,index) in productItem">
      <!-- 套餐详情  开始 -->
      <div class="page_taocan store_taocan">
        <div class="page_taocan_name">{{item.name}}</div>
        <div class="page_taocan_list">
          <div :class="item1.id===id?'page_taocan_box1':'page_taocan_box'" class="store_box" v-for="(item1,index1) in item.productItem"
            @click="selectnum(index1,index)">
            <div class="page_taocan_num">{{item1.name}}</div>
            <div class="page_taocan_num">售{{item1.price}}元</div>
            <img v-if="item1.id===id" class="page_taocan_checkimg" src="/static/newprojecticon/chongzhicheck.png" />
          </div>
        </div>
      </div>
      <!-- 套餐详情  结束 -->
    </div>
    <!-- 套餐类型  结束 -->
    <!-- 支付方式 开始 -->
    <div class="pagetype_taocan">
      <div class="pagepaytype_text">选择支付方式</div>
      <!-- <div class="page_shangpin_box" @click="weixinPay()">
        <div class="page_shangpin_mesgname1">
          <img src="/static/weixinpay.png" class="page_shangpin_mesglogo" />
          <div class="page_shangpin_mesgname">微信支付</div>
        </div>
        <div class="page_shangpin_usejifen">
          <div class="page_shangpin_shoujia">{{ price ? price+'元' : '' }}</div>
          <img :src="isWeixinPay? '/static/newicon/checkedicon.png' : '/static/newicon/checkicon.png'" class="page_checklogo" />
        </div>
      </div> -->
      <div class="page_shangpin_box" @click="yuePay()">
        <div class="page_shangpin_mesgname1">
          <img src="/static/jifenpay.png" class="page_shangpin_mesglogo" />
          <div class="page_shangpin_mesgname">积分支付</div>
        </div>
        <div class="page_shangpin_usejifen">
          <div class="page_shangpin_keyong">可用积分</div>
          <div class="page_shangpin_shoujia">{{amount}}</div>
          <img :src="isAmountPay? '/static/newicon/checkedicon.png' : '/static/newicon/checkicon.png'" class="page_checklogo" />
        </div>
      </div>
      <div class="page_shangpin_box" @click="showPopup()">
        <div class="page_shangpin_mesgname1">
          <img src="/static/cardPay.png" class="page_shangpin_mesglogo" />
          <div class="page_shangpin_mesgname">卡券支付</div>
        </div>
        <div class="page_shangpin_usejifen">
          <div class="page_shangpin_keyong">{{couponList.length}}张</div>
          <div class="page_shangpin_shoujia" v-if="selectedcardID">已选</div>
          <div class="page_shangpin_shoujia" v-else>未选</div>
          <img :src="selectedcardID ? '/static/newicon/checkedicon.png' : '/static/newicon/checkicon.png'" class="page_checklogo" />
        </div>
      </div>
    </div>
    <!-- 支付方式 结束 -->
    <!-- 支付 开始 -->
    <div class="page_button store_zhifu" @click="toRecharge()">
      <div class="page_zhifu">立即充值</div>
    </div>
    <!-- 支付 结束 -->
    <!-- 注意事项  开始 -->
    <div class="page_mesg" v-if="storeDeatil.detail">
      <div class="page_mesgtitle">
        <img class="page_mesgimg" src="/static/newprojecticon/title.png" />
        <div class="page_mesgtext">注意事项</div>
      </div>
      <div class="page_mesgtip">{{storeDeatil.detail}}</div>
    </div>
    <!-- 注意事项  结束 -->
    <!-- 卡券弹出层 开始 -->
    <van-popup v-model="showCardList" position="bottom" :style="{ height: '50%' }" >
      <div class="cardlist_popup_top">
        <div class="cardlist_popup_topcancel" @click="cancel()">取消</div>
        <div class="cardlist_popup_topcenter">选择卡券</div>
        <div class="cardlist_popup_topconfirm" @click="confirm()">确定</div>
      </div>
      <div class="cardlist_popup_list">
        <!-- <div class="cardlist_popup_box" v-for="(item,index) in couponList">
          <div class="cardlist_popup_boxtop">卡券名称：{{item.name}}</div>
          <div class="cardlist_popup_boxbot">到期日期：2020-09-23</div>
          <img class="cardlist_popup_img" src="/static/bukeyong.png" />
        </div> -->
        <div class="cardlist_popup_box1" v-for="(item,index) in couponList" @click="checkCard(index)">
          <div>
            <div class="cardlist_popup_boxtop">{{item.coupon.name}}</div>
            <div class="cardlist_popup_boxbot">到期日期：{{item.overdue_at}}</div>
          </div>
          <img class="cardlist-pop-check"
          :src="item.checked ? '/static/newicon/checkedicon.png':'/static/newicon/checkicon.png'" />

         <!-- <img class="cardlist_popup_img" src="/static/newicon/che.png" /> -->
        </div>
      </div>
    </van-popup>
    <!-- 卡券弹出层 结束 -->
  </div>
</template>

<script>
  import axios from 'axios'
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        amount: "", //用户所有积分数
        listDetail: {}, //上个页面传来的会员详情
        storeDeatil: {}, //接口获取商品详情
        productItem: [], //商品套餐分类列表
        phonenum: "", //手机充值账号
        price: "", //应付金额
        buttonClicked: false, // 防止支付重复点击,默认为false
        packageValue: 0, //套餐标识
        proindex: "", //套餐类型标识
        source_desc: "", //充值说明
        id: "", //套餐详情id
        storeList: [], //接口获取商品列表
        productDetailid: "",
        isWeixinPay: false,//是否为微信支付
        isAmountPay:true,//是否为余额支付
        showCardList: false, //是否显示卡券列表弹框: false,
        couponList: [],//卡券列表
        selectedcardID:"",//所选卡券id
        items:[],
      }
    },
    created() {
      if(this.$route.query.items){
        this.items = this.$route.query.items
        console.log("items",this.items);
      }
      if (this.$route.query.cate_id) {
        this.request("getstoreList", {
          cate_id: this.$route.query.cate_id
        })
      }
      this.request('getUserInfo')

    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      //改变商家
      todetail(e) {
        let that = this
        console.log("改变", e)
        let storeList = that.storeList

        storeList.map((item, index) => item.storeselect = index === Number(e))
        console.log("选择", storeList[e].storeselect)
        that.productDetailid = that.storeList[Number(e)].id
        this.request("getProductDetail", {
          id: this.productDetailid
        })
      },
      //关闭卡券弹出层
      guanbi() {
        this.showCardList = false
      },
      cancel(){
        this.showCardList = false
      },
      confirm(){
        this.showCardList = false
      },
      //显示卡券弹出层
      showPopup() {
        if (this.couponList.length == 0) {
          this.$toast({
            message: '暂无可用卡券',
          })
        } else {
          this.showCardList = true
        }
      },


      changegangbeng(e) {
        let that = this
        let APPshoppingDetail = that.APPshoppingDetail
        APPshoppingDetail.APPshoppingDetailbox.map((item, index) => item.shopSelect = index === Number(e))
      },
      //改变选择的套餐
      selectnum(e, proindex) {
        let that = this
        //获取套餐详情id
        that.id = that.productItem[Number(proindex)].productItem[Number(e)].id
        //that.productItem[Number(proindex)].productItem.map((item1, index1) => item1.packageChecked = index1===Number(e))
        //获取套餐详情价格
        that.price = that.productItem[Number(proindex)].productItem[Number(e)].price
        //获取套餐详情说明
        that.source_desc = that.productItem[Number(proindex)].productItem[Number(e)].source_desc
        //获取套餐类型标识
        that.proindex = Number(proindex)
        //获取套餐详情标识
        that.packageValue = Number(e)
        that.request("getCouponList")
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      //选择卡券支付
      checkCard(e){
        let that = this
        let couponlist = this.couponList
        couponlist.map(function(item, i) {
          if (i == Number(e)) {
            item.checked = true
            that.selectedcardID = item.id;
          } else {
            item.checked = false;
          }
        })
        that.couponList = couponlist;
      },
      //微信支付
      weixinPay() {
        if (!this.isWeixinPay) {
          this.isWeixinPay = true
          this.isAmountPay = false
        }
      },
      //余额支付
      yuePay() {
        if (!this.isAmountPay) {
          this.isAmountPay = true;
          this.isWeixinPay = false
        }
      },
      //支付
      toRecharge() {
        var order_param = {} //下单参数
        var that = this
        this.buttonClickedFun(1000) // 防止重复点击
        // 手机号码格式错误时顶部显示错误提示2秒
        // !/^1[2-9][0-9]{9}$/.test(Number(that.phonenum.toString().substring(0, 11)))
        // if (this.isphone){
        //   if (!(/^1[3456789]\d{9}$/.test(Number(that.phonenum)))) {
        //     this.$toast({
        //       message: '手机号格式错误'
        //     })
        //     return
        //   }
        // }
        // if (!that.qqnum) {
        //   this.$toast({
        //     message: '请输入账号'
        //   })
        //   return
        // }

        var product = that.storeDeatil
        // var productItem = that.productItem[that.proindex].productItem[that.packageValue]
        console.log("product", product)
        if (!(this.id)) {
          this.$toast({
            message: '请选择套餐',
          })
          return
        }
        order_param.amount = this.price
        order_param.type = 'online'
        order_param.product_type = 3
        order_param.product_id = product.id
        order_param.product_item_id = this.id
        // order_param.recharge_number = 0
        order_param.coupon_id = this.selectedcardID
        //order_param.recharge_number = that.phonenum || that.qqnum + ''
        let type = ""
        if((this.couponList.length>0) && !!this.selectedcardID){
          for(let index in this.couponList){
            if(this.couponList[index].checked){
              type = this.couponList[index].coupon.type
              if(type==2){
                this.price = this.price - this.couponList[index].coupon.spend_amount
              }else{
                this.price = this.couponList[index].coupon.amount
              }
            }
          }
        }
        // 判断用户是微信支付还是余额支付
        if (this.isWeixinPay) {
          Dialog.confirm({
              title: '提示',
              message: '是否使用微信支付?',
            })
            .then(() => {
              // order_param.pay_type = 'balance'
              // that.request('YeunifiedOrder', order_param)
              order_param.pay_type = 'wechatpay'
              that.request('WxunifiedOrder', order_param)
            })
            .catch(() => {
              return false;
            });
        } else if(this.isAmountPay) {
          if (parseFloat(that.amount) < parseFloat(that.price)) {
            Dialog.confirm({
                title: '提示',
                message: '积分不足，前往充值？',
              })
              .then(() => {
                that.$router.push({
                  path: "/account"
                })
              })
              .catch(() => {
                return false;
              });
          } else {
            Dialog.confirm({
                title: '提示',
                message: '是否用余额支付?',
              })
              .then(() => {
                order_param.pay_type = 'balance'
                that.request('YeunifiedOrder', order_param)
              })
              .catch(() => {
                return false;
              });
          }
        }
      },
      // 调用接口封装
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //获取个人信息余额
          case 'getUserInfo':
            //获取个人信息余额
            httper.get('/wechat/user/info', requestData, res => {
              if (res.code == 0) {
                var amount1 = res.data.account.amount.toFixed(2)
                that.amount = amount1
                console.log('amount1', amount1)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //获取商品列表
          case 'getstoreList':
            httper.get('product/get-online-by-cate', requestData, res => {
              if (res.code == 0) {
                console.log("商品列表", res)
                this.storeList = res.data
                this.storeList.map(v => {
                  this.$set(v, 'storeselect', false)
                  return v
                })
                if(this.items.pro_id){
                  for(let i in this.storeList){
                    if(this.storeList[i].id==this.items.pro_id){
                      this.storeList[i].storeselect = true
                      this.productDetailid = this.storeList[i].id
                    }
                  }
                }else{
                  this.productDetailid = this.storeList[0].id
                  this.storeList[0].storeselect = true
                }
                this.request("getProductDetail", {
                  id: this.productDetailid
                })
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            })
            break
            //卡券列表
          case "getCouponList":
            httper.get("/coupon/usable-coupon-by-pro", requestData, res => {
              if (res.data) {
                // console.log("res.data", res.data)
                // console.log("that.id",that.id)
                // res.data.map(function(item, i) {
                //   if (item.product_item_id == that.id && item.type == 2 && item.status!=2) {
                //     list.push(item)
                //   }
                // })
              that.couponList = res.data;
              }
              
            });
            break;
            //获取商品详情
          case 'getProductDetail':
            httper.get('/product/detail', requestData, res => {
              if (res.code == 0) {
                console.log("商品详情", res)
                this.storeDeatil = res.data
                this.productItem = this.storeDeatil.productItem
                /**
                 * //获取套餐详情id
                    that.id = that.productItem[Number(proindex)].productItem[Number(e)].id
                    //that.productItem[Number(proindex)].productItem.map((item1, index1) => item1.packageChecked = index1===Number(e))
                    //获取套餐详情价格
                    that.price = that.productItem[Number(proindex)].productItem[Number(e)].price
                    //获取套餐详情说明
                    that.source_desc = that.productItem[Number(proindex)].productItem[Number(e)].source_desc
                    //获取套餐类型标识
                    that.proindex = Number(proindex)
                    //获取套餐详情标识
                    that.packageValue = Number(e)
                    that.request("getCouponList")
                 */
                if(this.items.item_cate_id){
                  for(let i in this.productItem){
                    if(this.productItem[i].id == this.items.item_cate_id){
                      for(let j in this.productItem[i].productItem){
                        if(this.productItem[i].productItem[j].id == this.items.item_id){
                          that.id = that.productItem[i].productItem[j].id
                          that.price = that.productItem[i].productItem[j].price
                          that.source_desc = that.productItem[i].productItem[j].source_desc
                          that.proindex = i
                          that.packageValue = j
                        }
                      }
                    }
                  }
                  console.log("id111",this.id);
                  that.request("getCouponList",{
                    order_type:"online",
                    pro_id:this.productDetailid,
                    item_id:this.id
                  })
                }
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //余额支付
          case 'YeunifiedOrder':
            httper.post('/payment/place-order', requestData, res => {
              if (res.code == 0) {
                this.$router.push({
                  path: "orderListDetail",
                  query: {
                    id: res.data.order_no
                  }
                })
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信下单
          case 'WxunifiedOrder':
            httper.post('/payment/place-order', requestData, res => {
              console.log("微信支付信息", res)
              if (res.code === 0) {
                that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信取消下单
          case 'orderCancel':
            httper.post('/order/cancel', requestData, res => {
              console.log("取消", res)
              if (res.code === 0) {
                // that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
      //发起支付
      pay(payment_packet, order_no) {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no), false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
            document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
          }
        } else {
          this.jsApiCall(payment_packet, order_no);
        }
      },
      //调用微信支付
      jsApiCall(payment_packet, order_no) {

        let that = this
        if (!payment_packet) {
          this.$toast({
            message: '下单失败，请重试',
          })
          return
        }
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', payment_packet,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
              //跳去详情页order_no
              that.$router.push({
                path: '/orderListDetail',
                query: {
                  id: order_no
                }
              })
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              this.$toast({
                message: '取消支付'
              })
              this.request("orderCancel", {
                order_id: order_no
              })
              // that.$router.push({
              //   name: 'list'
              // })
            } else {
              this.$toast({
                message: '支付失败',
              })
            }
          }
        )
      },
    }
  }
</script>

<style>
  .store_shop {
    /* height: 290px; */
    height: 222px;
    top: -185px;

  }

  .store_shopList {
    /* justify-content: center; */
    width: 100%;
    height: 100%;

  }

  .store_shopbox {
    margin: 5px 5px;

  }

  .store_shopboximg {
    width: 100%;
    height: 100%;
  }

  .shopping_des {
    font-size: 14px;
  }

  .store_taocan {
    position: static;
    margin-top: 20px;
    height: auto;
  }

  .store_zhangaho {
    position: static;
    margin-top: 22px;
    height: auto;
  }

  ::-webkit-input-placeholder {
    text-align: start;
    font-size: 13px;
    font-weight: 400;
    color: rgba(187, 187, 187, 1);
  }

  .store_zhifu {
    margin-top: 22px;

  }

  .store_box {
    margin: 5px 5px;

    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  }

  .store_none {
    /*    height: 125px; */
    height: 10px;
    width: 100%;
    margin-top: -195px;
  }

  .reserceDesc_fuwuprice {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }


  .reserceDesc_fuwupricename {}

  .reserceDesc_fuwupricenum {
    font-size: 12px;
    font-weight: 400;
    color: #FD8C00;
  }

  .reserceDesc_jiesuancheck {
    display: flex;
    justify-content: end;
    align-items: center;
  }

  .reserceDesc_jiesuanpricenum {
    font-size: 12px;
    font-weight: 400;
    color: #FD8C00;
    margin-right: 10px;
  }

  .reserceDesc_button {
    margin-top: 21px;
  }

  /* pages/package/reserveDesc.wxss */


  .popup_top {
    display: flex;
    height: 30px;
    padding: 16px;
    border-bottom: 1px solid #d6d6d6;
    align-items: center;
    font-size: 18px;
  }

  .guanbi {
    width: 20px;
    height: 20px;
    margin-right: 130px;
  }

  .couponCell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }

  .reserceDesc_section {
    padding: 10px;
  }

  /* 卡券弹出层 开始 */
  .cardlist_popup_top {
    width: 100%;
    height: 18%;
    padding: 10px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-bottom: 1px solid #EEEEEE;
  }

  .cardlist_popup_topcancel {
    font-size: 14px;
    color: #969799;
  }

  .cardlist_popup_topcenter {
    font-size: 16px;
  }

  .cardlist_popup_topconfirm {
    font-size: 14px;
    color: #576b95;
  }

  .cardlist_popup_list {
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;

  }

  .cardlist_popup_box {
    width: 100%;
    height: 77px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    background-color: #EEEEEE;
    border-radius: 8px;
  }

  .cardlist_popup_box1 {
    width: 100%;
    height: 77px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    background-color: #FFFFFF;
    border: 1px solid #FD8C00;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .cardlist_popup_boxtop {
    color: #363636;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .cardlist_popup_boxbot {
    color: #BBBBBB;
    font-size: 14px;
  }
  .cardlist-pop-check{
    width: 14px;
    height: 14px;
  }

  .cardlist_popup_img {
    position: absolute;
    top: 0;
    right: 0;
    width: 69px;
    height: 23px;
  }

  /* 卡券弹出层 结束 */
</style>



// WEBPACK FOOTER //
// src/pages/shop/shoppingDetail.vue